import useReactiveZone from "reactive-zone";

import TaiBaseWidget from "../base.widget.js";

import telTemplate from './Tel.template.html';

class TelWidget extends TaiBaseWidget {

    zone = useReactiveZone(this);

    refPhone = this.zone.useElementRef('ref.inputPhone');
    refArea = this.zone.useElementRef('ref.inputArea');

    props = this.zone.injectPropToZone({
        area: '',
        phone: '',
    })

    template() {
        return telTemplate
    }

    getValue() {
        const phone = `+(${this.props.area}) ${this.props.phone}`;
        return phone;
    }

    clearValue() {
        this.props.area = '';
        this.props.phone = '';
    }

    onValidateRule(rule, value, format) {
        if (rule === 'maxlength' || rule === 'minlength') {
            value = this.props.phone;
        }
        return super.onValidateRule(rule, value, format);
    }

}

export default TelWidget;